/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { RichTextComponent } from '@msdyn365-commerce/core';
import { IRichtextViewProps } from './richtext';

export default (props: IRichtextViewProps) => {
    const { config } = props;
    return (
        <div
            data-enable-parallax='0'
            data-parallax-speed='0.5'
            data-background-images='{}'
            data-background-type='image'
            data-video-loop='true'
            data-video-play-only-visible='true'
            data-video-lazy-load='true'
            data-video-fallback-src=''
            data-element='inner'
            style={{
                justifyContent: 'flex-start',
                display: 'flex',
                flexDirection: 'column',
                backgroundPosition: 'left top',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'scroll',
                borderStyle: 'none',
                borderWidth: '1px',
                borderRadius: '0px',
                margin: '0px 0px 10px',
                padding: '10px'
            }}
        >
            <div
                data-content-type='text'
                data-appearance='default'
                data-element='main'
                style={{
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px',
                    padding: '0px'
                }}
            >
                <RichTextComponent text={config.content} />
            </div>
        </div>
    );
};
